import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Container, 
  Dropdown,
  Form,
  Nav,
  Tab,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import Card from "../../components/Card";
import moment from "moment";
import s5 from "../../assets/images/page-img/s5.jpg";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import "./styles.css";
import { getToken } from "../../utils/auth";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import useAuth from "../../utils/useAuth";
import Sponsored from "./Sponsored";
import { MdOutlineDone } from "react-icons/md";
import EventTab from './EventTab';
import { useTranslation } from "react-i18next";
const Event = () => {
  useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: "",
    startDate: "",
    endDate: "",
    location: "",
    note: "",
    category: "public",
  });

  const { t, i18n } = useTranslation();




  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "file") {
      const file = e.target.files[0];
      setFormData({
        ...formData,
        [name]: file,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const [categorypost, setCategorypost] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };


  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

const [eventType, setEventType] = useState("");
  const handleAllPost = async (updateData = false) => {
    try {
      const token = getToken();
      let url =  `${process.env.REACT_APP_URL}/api/event/all?page=${page}&limit=5`
      if(eventType)
      {
        url += `&searchFor=${eventType}`
      }
      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (updateData) {
        setPost(response.data.data.allEvents);
      } else {
        setPost((prevPost) => [...prevPost, ...response.data.data.allEvents]);
      }
      setHasMore(response.data.data.allEvents.length > 0);
    } catch (error) {
      console.log("Failed Fetching Event", error);
    }
  };

  useEffect(() => {
    handleAllPost();
  }, [page]);

  useEffect(() => {
    handleAllPost(true);
  }, [eventType]);

  const [upcoming, setUpcoming] = useState([]);
  const handleUpcoming = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );

      setUpcoming(response.data.data.allEvents);
    } catch (error) {
      console.log("Failed Fetching Upcoming Event", error);
    }
  };

  useEffect(() => {
    handleUpcoming();
  }, []);

 
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const intervalId = setInterval(() => {
      const date = new Date();
      const dayOfMonth = date.getDate();
      setCurrentDate(dayOfMonth);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);



  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
<div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg="12">
             <EventTab/>
              
            </Col>

            {/* <Col lg={4}>
              <Sponsored />
              <Card>
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">{t('upcoming_events')}</h4>
                  </div>
                </div>
                <Card.Body>
                  <ul className="media-story list-inline m-0 p-0">
                    {upcoming?.length === 0 ? (
                      <li className="d-flex mb-4 align-items-center">
                        <div className="stories-data ms-3">
                          <h5
                            className="mb-1"
                            style={{ fontWeight: "bold", color: "gray" }}
                          >
                            {t('no_upcoming_events')}
                          </h5>
                        </div>
                      </li>
                    ) : (
                      upcoming?.slice(0,4)?.map((data, index) => (
                        <li key={index} className="d-flex mb-4 align-items-center" >
                                                                           <img src={data?.image || s5} alt="story1" className="rounded-circle img-fluid" style={{ width: '50px', height: '50px' }} />
                                                                           <div className="stories-data ms-3">
                                                                               <h5 className="mb-1 hover-blue-event" style={{ fontWeight: 'bold', textTransform: 'capitalize', cursor:"pointer" }} onClick={() => window.open(`https://demo.dirido.com/event/${data?._id}`, '_blank')}>{data?.title}</h5>
                                                                               <p className="mb-0">
                                                                                   {moment(data?.startDate).format('MMMM Do YYYY, h:mm a')}
                                                                               </p>
                                                                               <p className="mb-0">
                                                                                   {t('organized_by')}: {data?.userId?.firstName} {data?.userId?.lastName}
                                                                               </p>
                                                                           </div>
                                                                       </li>
                      ))
                    )}
                  </ul>
                </Card.Body>
              </Card>
            </Col> */}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Event;
